// Centralized human "time-to-due" semantics shared by Dashboard, Scadenze and Mascalcia.
// Urgency (label + color + dot) is driven by the ACTUAL days remaining, NOT by the page's
// visualization horizon. Returns { code, label, color, dot }.
//   dot ∈ StatusDot statuses: "scaduto" | "in_scadenza" | "futuro"
const RED = "#DC2626";       // overdue
const TODAY = "#C2410C";     // today (stronger emphasis)
const ORANGE = "#EA6A0C";    // 1-7 days
const AMBER = "#B98900";     // 8-10 days (light amber)
const NEUTRAL = "#5F6B64";   // > 10 days

const gg = (n) => `${n} ${n === 1 ? "giorno" : "giorni"}`;

export function daysUntil(iso) {
  if (!iso) return null;
  const d = new Date(String(iso).slice(0, 10) + "T00:00:00");
  const t = new Date(); t.setHours(0, 0, 0, 0);
  return Math.round((d - t) / 86400000);
}

export function timeToDue(iso) {
  const diff = daysUntil(iso);
  if (diff === null) return { code: "none", label: "—", color: NEUTRAL, dot: "futuro" };
  if (diff < 0) return { code: "overdue", label: `scaduto da ${-diff} gg`, color: RED, dot: "scaduto" };
  if (diff === 0) return { code: "today", label: "oggi", color: TODAY, dot: "in_scadenza" };
  if (diff === 1) return { code: "tomorrow", label: "domani", color: ORANGE, dot: "in_scadenza" };
  if (diff <= 7) return { code: "days", label: `tra ${gg(diff)}`, color: ORANGE, dot: "in_scadenza" };
  if (diff <= 10) return { code: "amber", label: `tra ${gg(diff)}`, color: AMBER, dot: "in_scadenza" };
  const weeks = Math.round(diff / 7);
  return { code: "weeks", label: `tra ${weeks} settiman${weeks === 1 ? "a" : "e"}`, color: NEUTRAL, dot: "futuro" };
}
